const api = '/notification-service/api/external';
export const notificationsContext = {
  notifications: `${api}/targetNotifications`,
  notification: `${api}/targetNotifications/{id}`,
};
